/**
 * Product Offer Service - API calls for product offers (admin)
 */

import api from './api';

const BASE_PATH = '/admin/product-offers';

/**
 * Create a new product offer
 * @param {Object} offerData - Offer data including productId, title, description, etc.
 */
export const createProductOffer = async (offerData) => {
  try {
    return await api.post(BASE_PATH, offerData);
  } catch (error) {
    console.error('Failed to create product offer:', error);
    throw error;
  }
};

/**
 * Get a product offer by its ID
 * @param {string} id - The offer ID
 */
export const getProductOffer = async (id) => {
  try {
    return await api.get(`${BASE_PATH}/${id}`);
  } catch (error) {
    console.error('Failed to get product offer:', error);
    throw error;
  }
};

/**
 * Get the product offer for a specific product (if exists)
 * @param {string} productId - The product ID
 * @returns {Object|null} - The offer or null if no offer exists
 */
export const getProductOfferByProductId = async (productId) => {
  try {
    const response = await api.get(`${BASE_PATH}/product/${productId}`);
    return response.offer;
  } catch (error) {
    console.error('Failed to get product offer by product ID:', error);
    throw error;
  }
};

/**
 * Update an existing product offer
 * @param {string} id - The offer ID
 * @param {Object} offerData - Updated offer data
 */
export const updateProductOffer = async (id, offerData) => {
  try {
    return await api.put(`${BASE_PATH}/${id}`, offerData);
  } catch (error) {
    console.error('Failed to update product offer:', error);
    throw error;
  }
};

/**
 * Delete a product offer
 * @param {string} id - The offer ID
 */
export const deleteProductOffer = async (id) => {
  try {
    return await api.delete(`${BASE_PATH}/${id}`);
  } catch (error) {
    console.error('Failed to delete product offer:', error);
    throw error;
  }
};

/**
 * List all product offers (admin)
 * @param {Object} params - Query params (limit, offset)
 */
export const listProductOffers = async (params = {}) => {
  try {
    const query = new URLSearchParams(params).toString();
    return await api.get(`${BASE_PATH}${query ? `?${query}` : ''}`);
  } catch (error) {
    console.error('Failed to list product offers:', error);
    throw error;
  }
};

export default {
  createProductOffer,
  getProductOffer,
  getProductOfferByProductId,
  updateProductOffer,
  deleteProductOffer,
  listProductOffers
};
